import { RouteObject } from "react-router-dom";
import { Landing } from "./components/landing/landing";
import { ManufacturerLanding } from "./components/details/landing";

export interface ManufacturersRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: ManufacturersRoute[];
}

export const manufacturersRoutes: ManufacturersRoute[] = [
  {
    path: "/ax/settings/manufacturers",
    element: <Landing />,
  },
  {
    path: "/ax/settings/manufacturers/view/:id",
    element: <ManufacturerLanding />,
  },
];